import React from 'react';
import { TabDescriptor } from '../types';
import { UnreadCounts } from '../../../services/messagerie/useUnreadCounts';

interface OperationTabsProps {
  descriptors: TabDescriptor[];
  activeIndex: number;
  onSelect: (index: number) => void;
  unreadCounts?: UnreadCounts | null;
}

// Nombre de non-lus a afficher en badge pour un onglet (0 = pas de badge). BDC : messagerie seule.
const badgeCountFor = (tab: TabDescriptor, unreadCounts?: UnreadCounts | null): number => {
  if (!unreadCounts) return 0;
  return tab.kind === 'messagerie' ? unreadCounts.messagerie : 0;
};

// Survol d'un onglet DESACTIVE : dit a l'acheteur QUAND l'onglet s'ouvrira (oriente deblocage), au
// lieu du "Non disponible dans ce statut" generique. Vocabulaire calque sur le MS (reference validee),
// adapte au BC : "marche signe" -> "bon de commande signe". Un onglet actif n'a pas de survol.
const tooltipFor = (tab: TabDescriptor): string => {
  if (tab.inactive) return 'Fonctionnalité en cours de développement';
  if (!tab.disabled) return '';
  switch (tab.kind) {
    case 'notification':
    case 'messagerie':
    case 'evaluation':
      return 'Disponible dès le bon de commande signé';
    case 'offre':
      // L'offre d'un rang n'existe qu'une fois SA consultation lancee : on nomme la condition reelle
      // plutot qu'une "ouverture de rang" vague, et on cite le rang que porte le descripteur.
      return `Disponible dès la consultation de rang ${tab.rang} lancée`;
    case 'consultation':
      // Un rang ne s'ouvre qu'apres refus/expiration du rang precedent.
      return 'Disponible dès l’ouverture de ce rang';
    default:
      return 'Non disponible dans ce statut';
  }
};

// Barre d'onglets pilotee par descripteurs types : pas d'index magique, pas de regex.
const OperationTabs: React.FC<OperationTabsProps> = ({ descriptors, activeIndex, onSelect, unreadCounts }) => (
  <div className="opbc__tab-nav">
    <div className="opbc__tab-nav-left">
      {descriptors.map((tab, index) => {
        const locked = tab.disabled || tab.inactive;
        const tooltip = tooltipFor(tab);
        const badge = badgeCountFor(tab, unreadCounts);
        const classes = ['opbc__tab-button'];
        if (index === activeIndex) classes.push('active');
        if (tab.inactive) classes.push('inactive');
        if (tab.disabled) classes.push('disabled');

        return (
          <button
            key={tab.key}
            type="button"
            className={classes.join(' ')}
            onClick={() => !locked && onSelect(index)}
            disabled={locked}
            title={tooltip}
            data-tooltip={tooltip}
          >
            {tab.label}
            {badge > 0 && <span className="opbc__tab-badge">{badge}</span>}
          </button>
        );
      })}
    </div>
  </div>
);

export default OperationTabs;
